<template>
  <div class="bl-backdrop-overlay">
    <div
      class="bl-backdrop"
      :class="backdropClass"
      :style="
        type === 'error' || empty ? { width: '40rem' } : { width: maxWidth }
      "
    >
      <div v-if="title || description" class="bl-backdrop-header">
        <div class="bl-backdrop-header-container">
          <BlIcon
            v-if="type === 'error'"
            icon="warning"
            color="error"
            class="bl-backdrop-header-icon"
          />
          <BlTextTitle4 v-if="title" :text="title" />
        </div>
        <BlTextBody2
          v-if="description"
          :text="description"
          class="break-words flex-wrap"
          :class="{ 'lg:w-140': maxWidth === 'unset' }"
        />
      </div>
      <div v-if="!empty" class="bl-backdrop-body">
        <slot />
      </div>
      <div v-if="footer" class="bl-backdrop-footer">
        <BlInputButton
          :label="cancelLabel"
          type="plain"
          @clicked="$emit('backdrop-close')"
          class="bl-backdrop-action"
        />
        <BlInputButton
          v-if="label"
          :label="label"
          :type="type === 'error' ? 'error' : ''"
          :disabled="disabled"
          :loading="submitLoading"
          @clicked="$emit('backdrop-action')"
          class="bl-backdrop-action lg:max-w-64"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BlIcon from "./BlIcon.vue";
import BlInputButton from "./BlInputButton.vue";
import BlTextBody2 from "./BlTextBody2.vue";
import BlTextTitle4 from "./BlTextTitle4.vue";
export default {
  components: { BlInputButton, BlTextTitle4, BlTextBody2, BlIcon },
  props: {
    backdropClass: { type: String, required: false },
    title: { type: String, required: false },
    description: { type: String, required: false },
    type: { type: String, default: "primary" },
    label: { type: String, required: false },
    cancelLabel: { type: String, required: false, default: "Cancel" },
    empty: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    submitLoading: { type: Boolean, default: false },
    maxWidth: { type: String, default: "unset" },
    footer: { type: Boolean, default: true }
  }
};
</script>

<style scoped lang="scss">
.bl-backdrop-overlay {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .bl-backdrop {
    position: relative;
    // padding: 2.5rem;
    border-radius: 1.25rem;
    box-sizing: border-box;
    background: var(--background-depth-one-color);
    display: flex;
    gap: 1rem;
    flex-direction: column;
    min-width: 32rem;
    .bl-backdrop-header {
      position: relative;
      padding: 2rem 2rem 0 2rem;
      width: 100%;
      display: flex;
      gap: 0.5rem;
      flex-direction: column;
      text-wrap: wrap;
      .bl-backdrop-header-container {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        gap: 0.75rem;
        .bl-backdrop-header-icon {
          position: relative;
          width: 1.5rem;
          height: 1.5rem;
        }
      }
    }
    .bl-backdrop-body {
      position: relative;
      // padding: 0 2.5rem 0 2.5rem;
      width: 100%;
      display: flex;
      flex-direction: column;
    }
    .bl-backdrop-footer {
      position: relative;
      padding: 0 2rem 2rem 2rem;
      width: 100%;
      display: flex;
      gap: 0.5rem;
      justify-content: flex-end;
    }
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
  }
  @media only screen and (max-width: 1023px) {
    height: calc(var(--vh) * 100);
    .bl-backdrop {
      min-width: 100vw !important;
      max-width: 100vw !important;
      width: 100vw !important;
      height: 100vh;
      height: calc(var(--vh) * 100);
      padding: 0;
      flex-grow: 0;
      flex-shrink: 0;
      border-radius: 0;
      gap: 1rem;
      .bl-backdrop-header {
        padding: 1rem 1rem 0 1rem;
      }
      .bl-backdrop-body {
        margin-bottom: 4.375rem;
      }
      .bl-backdrop-footer {
        position: absolute;
        left: 0;
        bottom: 0;
        height: 4.375rem;
        width: 100%;
        padding: 0 1rem 0 1rem;
        border-top: 1px solid var(--border-color);
        background: var(--background-depth-one-color);
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        .bl-backdrop-action {
          position: relative;
          width: 100%;
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BlBackdrop.vue